import { Box } from "@mui/system";
import ProjectFrameVideo from "./ProjectFrameVideo";
import "../css/project.css";
import ProjectFrame from "./ProjectFrame";
import  ForwardProxy from "../images/Forward-Proxy-01.png";
export default function Project(){
    const title="CRUX-Elearning Full stack";
    const date="May 2022";
   const src="https://www.youtube.com/embed/F9eYfIAQJrM";
   const body=`
   It has role based access for teacher and student using custom claim. 
   Option available( for Logged in user) 
                 1.Create class(anyone) 
   2.Join class(anyone) 
   3.Create assignment(teacher) 
   4.Submit assignment(student) 
   5.View student's submission(teacher) 
   5.Annoucement(anyone) 
   6.Personal chat(anyone) 
   7.Video conference(based on Mesh methodology) (anyone)`;
   const link="https://dreamy-cocada-c3b564.netlify.app/";
    return(
        <div id="projectcontainer">
            <Box sx={{display:"flex",columnGap:"2%",rowGap:"15px",flexWrap:"wrap"}}>
            <ProjectFrameVideo title={title} date={date} src={src} body={body} link={link} />
            <ProjectFrameVideo title="wireless File Transfer without internet" 
            date="Nov 2022"
            src="https://www.youtube.com/embed/Kj4TKxhqoIA"
             body="Desktop App and Mobile Browser
                   Simply transfer File to PC without internet or data cable
                   Made using Node.js,Electron,Bootstrap template" 
                   link="https://github.com/tarakes/filetransfer" />
                   <ProjectFrameVideo title="Leetcode contest rank fetcher chrome extension" 
                   date="Jun 2022"
                   src="https://www.youtube.com/embed/WRGy2Ne_Eh4"
                   body="Chrome extension, This allows you to add friends to your local storage and fetch their Leetcode contest rank/score"
                   link="https://www.linkedin.com/in/tarakeswar-mondal-810aab204/details/projects/"
                   />
                   <ProjectFrame   
                   title="Forward Proxy server"
                   date=" Oct 2022"
                   src={ForwardProxy}
                   body="Proxy server made using Node Js. When if client send a HTTP CONNECT(with TLS) request to proxy,it makes a nearly TCP 
                   connection with the remote server and create a TUNNEL. After making connection it send acknowldegement to client.
                   All packets are bypassed via proxy server."
                   link="https://github.com/tarakes/proxyserver"
                   />
            </Box>
        </div>
    );
}
